import React, { useMemo, useContext, Fragment, Dispatch, SetStateAction } from 'react';
import classnames from 'classnames';
import { Icon } from '@/components';
import { i18n } from '@/utils';
import { SockTaskStatus, ProductContext } from '.';
import styles from './style.less';

interface ErrorProps {
  /** 任务状态 */
  status: SockTaskStatus;
  /** 关闭回调 */
  onClose: () => void;
  /** zuploader 插件显影状态控制函数 */
  setZuploaderVisible: Dispatch<SetStateAction<boolean>>;
  /** 重新上传 */
  reUpload: () => void;
}

const Error: React.FC<ErrorProps> = ({ status, onClose, setZuploaderVisible, reUpload }) => {

  // 设置任务状态函数
  const { setTaskStatus } = useContext(ProductContext);
  // 报错文案
  const errorText = useMemo(() => {
    switch (status) {
      case SockTaskStatus.NetworkError:
        return i18n.format('modules.new.sock.network.error');
      case SockTaskStatus.CropError:
        return i18n.format('modules.new.sock.ai.crop.error');
      default:
        return;
    }
  }, [ status ]);

  return (
    <div className={styles.error}>
      <div className={styles.close} onClick={onClose}>
        <Icon type='close' color='#000' size={30} />
      </div>
      <div className={styles.content}>
        <div className={styles.errorImage}>
          <img src={require('@/assets/new-sock/error.png')} />
        </div>
        <div className={styles.errorText}>{errorText}</div>
        <div className={styles.buttonList}>
          {status === SockTaskStatus.CropError && (
            <Fragment>
              <div
                className={classnames(styles.mainButton, styles.button)}
                onClick={() => setZuploaderVisible(true)}
              >
                <Icon type='photo' color='#F56C6C' size={20} className={styles.icon} />
                <span>{i18n.format('modules.new.sock.replace.photo')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setTaskStatus(SockTaskStatus.Crop)}
              >
                <Icon type='scissors' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.new.sock.crop.myself')}</span>
              </div>
            </Fragment>
          )}
          {status === SockTaskStatus.NetworkError && (
            <Fragment>
              <div
                className={classnames(styles.mainButton, styles.button)}
                onClick={() => reUpload()}
              >
                <Icon type='refresh' color='#F56C6C' size={20} className={styles.icon} />
                <span>{i18n.format('modules.new.sock.try.again')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setTaskStatus(SockTaskStatus.Crop)}
              >
                <Icon type='scissors' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.new.sock.crop.myself')}</span>
              </div>
              <div
                className={classnames(styles.otherButton, styles.button)}
                onClick={() => setZuploaderVisible(true)}
              >
                <Icon type='photo' color='#000' size={20} className={styles.icon} />
                <span>{i18n.format('modules.new.sock.replace.photo')}</span>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

export default Error;
